import mainRequest from '../request';

export const getGatheringList = async (params) => {
    try {
        const response = await mainRequest.post('/v2/adminGathering/list', params);
        return response?.data;
    } catch (err) {
        return {
            ok: false,
            status: err.response.status || 500,
            message: err.response.data.message || '서버 에러',
        };
    }
};

export const getGatheringListCnt = async (params) => {
    try {
        const response = await mainRequest.post('/v2/adminGathering/list/count', params);
        return response?.data;
    } catch (err) {
        return {
            ok: false,
            status: err.response.status || 500,
            message: err.response.data.message || '서버 에러',
        };
    }
};

export const getGatheringDetail = async (gatheringId) => {
    try {
        const response = await mainRequest.get(`/v2/adminGathering/detail?gathering_id=${gatheringId}`);

        return response?.data;
    } catch (err) {
        return {
            ok: false,
            status: err.response.status || 500,
            message: err.response.data.message || '서버 에러',
        };
    }
};
